/* Classic customer account pages. Added by Oleg @ IAKOE.
   <ts-account-login>: sign in <-> recover password panels (link, #recover hash,
   and the recover form coming back with a result).
   <ts-account-addresses>: open/close the add and edit forms in place, confirm
   deletes, and wire every country select to its province select with Shopify's
   CountryProvinceSelector (shopify_common.js, loaded by the addresses template). */

if (!customElements.get('ts-account-login')) {
  customElements.define(
    'ts-account-login',
    class TsAccountLogin extends HTMLElement {
      connectedCallback() {
        this.login = this.querySelector('[data-login-panel]');
        this.recover = this.querySelector('[data-recover-panel]');
        if (!this.login || !this.recover) return;

        this.addEventListener('click', (event) => {
          if (event.target.closest('[data-recover-open]')) {
            event.preventDefault();
            this.show(true);
          } else if (event.target.closest('[data-recover-close]')) {
            event.preventDefault();
            this.show(false);
          }
        });

        const hasResult = this.recover.querySelector('[data-recover-result]');
        if (hasResult || location.hash === '#recover') this.show(true, false);
      }

      show(recover, moveFocus = true) {
        this.login.hidden = recover;
        this.recover.hidden = !recover;
        if (!moveFocus) return;
        const field = (recover ? this.recover : this.login).querySelector('input[type="email"]');
        if (field) field.focus();
      }
    }
  );
}

if (!customElements.get('ts-account-addresses')) {
  customElements.define(
    'ts-account-addresses',
    class TsAccountAddresses extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-address-fields]').forEach((fields) => {
          const key = fields.dataset.addressFields;
          if (window.Shopify && Shopify.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector('AddressCountry_' + key, 'AddressProvince_' + key, {
              hideElement: 'AddressProvinceField_' + key,
            });
          }
          if (fields.querySelector('[role="alert"]')) this.toggle(key, true);
        });

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-address-toggle]');
          if (!button || !this.contains(button)) return;
          const key = button.dataset.addressToggle;
          const form = this.querySelector('[data-address-form="' + key + '"]');
          this.toggle(key, form ? form.hidden : false);
        });

        this.addEventListener('submit', (event) => {
          const form = event.target.closest('[data-address-delete]');
          if (form && !window.confirm(form.dataset.confirmMessage)) event.preventDefault();
        });
      }

      toggle(key, open) {
        const form = this.querySelector('[data-address-form="' + key + '"]');
        if (!form) return;
        form.hidden = !open;
        this.querySelectorAll('[aria-controls="AddressForm_' + key + '"]').forEach((b) => {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        if (open) {
          const first = form.querySelector('input:not([type="hidden"])');
          if (first) first.focus();
        }
      }
    }
  );
}
